package app.nestbridge.feature.invitations.usecase

import app.nestbridge.feature.invitations.model.Invitation
import app.nestbridge.feature.invitations.service.InvitationService
import me.tatarka.inject.annotations.Inject

@Inject
class FindInvitationByIdUseCase(
    private val invitationService: InvitationService,
) {
    suspend operator fun invoke(invitationId: String): Result<Invitation?> =
        invitationService.findById(invitationId)
}
